import { queryOptions } from '@tanstack/react-query'

import { getEntityAllDocumentsDownload, getEntityDocument, getEntityDocuments } from './documents.service'

export const entityDocumentsQueryOptions = (entityId: string, isNewRequiredActionsModels: boolean) =>
  queryOptions({
    queryKey: ['entityDocuments', entityId, isNewRequiredActionsModels],
    queryFn: async () => getEntityDocuments(entityId, isNewRequiredActionsModels),
  })

export const entityDocumentQueryOptions = (
  entityId: string,
  documentId: string,
  documentName: string,
  isNewRequiredActionsModels: boolean
) =>
  queryOptions({
    queryKey: ['entityDocument', entityId, documentId, documentName, isNewRequiredActionsModels],
    queryFn: async () => getEntityDocument(entityId, documentId, documentName, isNewRequiredActionsModels),
  })

export const entityAllDocumentsDownloadQueryOptions = (
  customerId: string,
  entityId: string,
  isNewRequiredActionsModels: boolean
) =>
  queryOptions({
    queryKey: ['entityAllDocumentsDownload', entityId, customerId, isNewRequiredActionsModels],
    queryFn: async () => getEntityAllDocumentsDownload(customerId, entityId, isNewRequiredActionsModels),
  })
